// src/components/IconSelector.js
import React, { useState, useMemo } from 'react';
import Icon from './Icon';

// Cargar todos los iconos
const req = require.context('../../images/iconComponents', false, /\.js$/);
const allIcons = req.keys().reduce((acc, path) => {
  const name = path.replace('./', '').replace('.js', '');
  acc.push(name);
  return acc;
}, []);

// Cuántos íconos mostrar por página
const ICONS_PER_PAGE = 50;

export default function IconSelector({ onChange, value }) {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState(value || '');

  // Filtrar íconos por texto
  const filteredIcons = useMemo(() => {
    return allIcons.filter((name) => name.toLowerCase().includes(search.toLowerCase()));
  }, [search]);

  // Calcular paginación
  const totalPages = Math.ceil(filteredIcons.length / ICONS_PER_PAGE);
  const paginatedIcons = filteredIcons.slice(
    (page - 1) * ICONS_PER_PAGE,
    page * ICONS_PER_PAGE
  );

  const handleSelect = (name) => {
    let response = {target: {id: 'icon', value: name}}
    setSelected(name);
    if (onChange) onChange(response);
  };

  const goToPage = (p) => {
    if (p >= 1 && p <= totalPages) setPage(p);
  };

  return (
    <div style={{ padding: '1rem' }}>
      <input
        type="text"
        placeholder="Buscar ícono..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1); // volver a la primera página si cambia la búsqueda
        }}
        style={{
          padding: '8px',
          width: '100%',
          marginBottom: '1rem',
          fontSize: '16px',
        }}
      />

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        {paginatedIcons.filter((name) => name != 'index' ).map((name) => (
          <button
            key={name}
            type='button'
            onClick={() => handleSelect(name)}
            style={{
              border: selected === name ? '2px solid blue' : '1px solid #ccc',
              padding: 8,
              borderRadius: 6,
              background: 'white',
              cursor: 'pointer',
            }}
          >
            <Icon name={name} size={32} color='#062147' />
          </button>
        ))}
      </div>

      {/* Controles de paginación */}
      <div style={{ marginTop: '1rem', display: 'flex', gap: '8px', alignItems: 'center' }}>
        <button onClick={() => goToPage(page - 1)} type='button' disabled={page === 1} className='btn btn-secondary' >
          Anterior
        </button>
        <span>Página {page} de {totalPages}</span>
        <button onClick={() => goToPage(page + 1)} type='button' className='btn btn-secondary' disabled={page === totalPages}>
          Siguiente
        </button>
      </div>
    </div>
  );
}
